// Opens the Zoom Contact Center web chat (injected via GTM) from the Live Chat
// button on the Customer Service page. The button lives in a merchant-owned
// custom HTML block, so it's found by its chat icon image rather than an
// attribute the theme controls. If the SDK hasn't loaded (e.g. blocked), the
// link's default action runs as a fallback.
const liveChatLink = document
  .querySelector('.customer-service-box-3 img[src*="/files/chat"]')
  ?.closest("a");

liveChatLink?.addEventListener("click", (event) => {
  const sdk = window.zoomCampaignSdk;

  if (typeof sdk?.open !== "function") return;

  event.preventDefault();
  sdk.waitForReady().then(() => sdk.open());
});
